import React from 'react';
import Paper from "@mui/material/Paper";
import styled from "styled-components";
import {DataItemStyled} from "./Edge";
import CameraLive from "../../camera/CameraLive";

const WrapperStyled = styled.div`
    position: relative;

    .main-title {
        margin-bottom: 7px;
        padding: 13px 0 0 13px;
    }
`;

const DataWrapperStyled = styled.div`
    padding: 0 0 0 13px;
`;

const Camera = ({item}) => {
    const data = [
        {
            title: "IP", data: item.ip
        },
    ];

    const {streamFullRtspUrl,profile_list, rotate } = item;


    return (
        <Paper elevation={3}>
            <WrapperStyled>
                <div className="main-title">
                    {item.name}
                </div>
                <DataWrapperStyled>
                    {data.map(d => {
                        return (
                            <DataItemStyled
                                key={d.title}
                            >
                                <div className="title">{d.title}:</div>
                                <div className="data">{d.data}</div>
                            </DataItemStyled>
                        );
                    })}
                </DataWrapperStyled>
                <CameraLive profile_list={profile_list} rtspUrl={streamFullRtspUrl} rotate={rotate} rotateEnabled={true} resolution={`480x270`}/>
            </WrapperStyled>
        </Paper>
    );
};

export default Camera;